import ApplicationController from "./application_controller";

export default class TemplatableController extends ApplicationController {
    static targets = ['container', 'item', 'template']

    declare containerTarget: HTMLElement
    declare itemTargets: HTMLElement[]
    declare templateTarget: HTMLTemplateElement

    deleteItem(event: MouseEvent) {
        console.log(event);
        const element = this.itemTargets.find((item) => item.contains(event.target as HTMLElement));
        console.log("target", element)
        element?.remove()
    }

    addItem() {
        const clone = this.templateTarget.content.children[0].cloneNode(true) as HTMLElement;
        this.containerTarget.appendChild(clone)
    }
}
